var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeadsetSvgrepoCom1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#9199A3",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 511.787 511.787",
    strokeWidth: 2,
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 2,
    d: "M458.667,267.413v-0.853c0-34.347-12.907-57.92-33.493-62.933c-5.44-79.04-77.867-139.733-169.6-139.733 s-164.16,60.693-169.6,139.84c-20.267,5.333-32.853,28.8-32.853,62.827v0.853C19.307,271.147,0,293.12,0,329.493 C0,367.04,19.307,389.76,53.12,393.6v0.96c0,14.613,0,53.333,42.667,53.333h42.667c5.867,0,10.667-4.8,10.667-10.667v-224 c0-5.867-4.8-10.667-10.667-10.667h-31.04c5.973-67.627,67.627-117.333,148.267-117.333s142.293,49.707,148.267,117.333h-30.613 c-5.867,0-10.667,4.8-10.667,10.667v224c0,5.867,4.8,10.667,10.667,10.667H416c42.667,0,42.667-38.72,42.667-53.333v-0.96 c33.813-3.84,53.12-26.56,53.12-64.107C511.787,293.12,492.48,271.147,458.667,267.413z M53.12,372.373 c-21.653-3.093-31.787-16.96-31.787-42.88c0-24.32,10.453-37.76,31.787-40.747V372.373z M127.787,223.893c0,0,0,202.667,0,202.667 h-32c-14.507,0-21.333-4.8-21.333-32v-128c0-15.893,4.373-42.667,20.587-42.667H127.787z M437.333,394.56 c0,27.2-6.933,32-21.333,32h-32V223.893h32.747c16.213,0,20.587,26.773,20.587,42.667V394.56z M458.667,372.373v-83.627 c21.333,3.093,31.787,16.533,31.787,40.747C490.453,355.413,480.32,369.28,458.667,372.373z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadsetSvgrepoCom1);
export default __webpack_public_path__ + "static/media/headset-svgrepo-com (1).8f3385b3f986ae59b5ce95bf5b090993.svg";
export { ForwardRef as ReactComponent };